<template>
	<span>
		<Row>
			<div class="text">{{ item.text }}</div>
			<div class="pl-2" v-if="item.billingFeatureId && isUpgradeRequired">
				<component :is="indicator" :billingFeatureId="item.billingFeatureId" />
			</div>
		</Row>
		<div class="subtext">{{ item.subtext }}</div>
	</span>
</template>

<script>
export default {
	name: 'ProjectRoleSelectorItem',
	props: {
		item: { type: Object },
		isUpgradeRequired: { type: Boolean, default: false },
		indicator: { type: Object, default: null },
	},
};
</script>

<style scoped lang="scss">
.text {
	padding-top: 4px;
	font-size: 14px;
}
.subtext {
	margin-top: -4px;
	padding-bottom: 4px;
	font-size: 11px;
	color: #9e9e9e;
}
</style>
